import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import { useAuth } from "@/auth";
import { ContactsTab } from "@/components/prospect/ContactsTab";
import { FileDetail } from "@/components/prospect/FileDetail";
import { FilesTab } from "@/components/prospect/FilesTab";
import { LogsTab } from "@/components/prospect/LogsTab";
import { RemindersTab } from "@/components/prospect/RemindersTab";
import { SettingsTab } from "@/components/prospect/SettingsTab";
import { ScriptsTab } from "@/components/prospect/ScriptsTab";
import "@/prospect.css";

const TABS = [["files", "Fichiers"], ["contacts", "Base contacts"], ["scripts", "Scripts d'appel"], ["logs", "Journal de synchro"], ["settings", "Paramètres"]];

export default function ProspectFilesPage() {
  const { user } = useAuth();
  const admin = user?.role === "admin";
  const [tab, setTab] = useState("files");
  const [openId, setOpenId] = useState(null);
  const [contactId, setContactId] = useState(null);
  const { search, key: navKey, pathname } = useLocation();
  const navigate = useNavigate();
  useEffect(() => { const q = new URLSearchParams(search); if (q.get("file")) { setTab("files"); setOpenId(q.get("file")); setContactId(q.get("contact") ? `${q.get("contact")}|${navKey}` : null); } }, [search, navKey]);
  const tabs = admin ? [TABS[0], ["reminders", "Mes rappels"], ...TABS.slice(1)] : [TABS[0], ["reminders", "Mes rappels"]];
  return (
    <div className="ps-page" data-testid="prospect-page">
      <header className="ps-top"><div><p className="eyebrow">FICHIERS DE PROSPECTION</p><h1>Fichiers en cours</h1></div></header>
      <nav className="ps-tabs">{tabs.map(([k, l]) => <button key={k} type="button" className={tab === k ? "on" : ""} onClick={() => { setTab(k); setOpenId(null); }} data-testid={`prospect-tab-${k}`}>{l}</button>)}</nav>
      {tab === "files" && (openId ? <FileDetail key={openId} id={openId} contactId={contactId} admin={admin} onBack={() => { setOpenId(null); setContactId(null); navigate(pathname, { replace: true }); }} onContactClose={() => navigate(`${pathname}?file=${openId}`, { replace: true })} /> : <FilesTab admin={admin} onOpen={setOpenId} />)}
      {tab === "reminders" && <RemindersTab />}
      {tab === "contacts" && admin && <ContactsTab />}
      {tab === "logs" && admin && <LogsTab />}
      {tab === "settings" && admin && <SettingsTab />}
      {tab === "scripts" && admin && <ScriptsTab />}
    </div>
  );
}
